import React, {memo, useMemo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtons from './RadioButtons';
import {MILITARY_PROPS} from '../../../../shared/constants/RadioProps';
import MenuButton from './MenuButton';
import {
  ARMY_ENLISTED,
  ARMY_WARRANT,
  ARMY_OFFICER,
  MARINES_ENLISTED,
  MARINES_WARRANT,
  MARINES_OFFICER,
  NAVY_ENLISTED,
  NAVY_WARRANT,
  NAVY_OFFICER,
  AIRFORCE_ENLISTED,
  AIRFORCE_OFFICER,
  COASTGUARD_ENLISTED,
  COASTGUARD_WARRANT,
  COASTGUARD_OFFICER,
} from '../../../../shared/constants/military/ranks';
import {MILITARY_STATUSES} from '../../../../shared/constants/MilitaryStatusSlugs';
import {months, days} from '../../../../shared/constants/MonthsAndDays';
import {generateYears, isMilitaryUser} from '../../../../shared/utils/Helpers';
import ToggleSwitch from '../ToggleSwitch';
import styles from './EditMyProfile.module.css';
import {projectConfig} from '../../../../shared/project-info/projectConfig';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    marginLeft: '25px',
    display: 'flex',
  },
  svg: {
    marginRight: '10px',
  },
  expansionPanel: {
    padding: '8px 40px 16px',
  },
  typography: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const {
  status_radio_props,
  branch_radio_props,
  disability_radio_props,
  zone_radio_props,
  deployment_radio_props,
} = MILITARY_PROPS;

const ExpansionPanelComponent = memo(
  ({
    label,
    Icon,
    militaryStatus,
    militaryFamily,
    militaryBranch,
    militaryRank,
    disability,
    militaryETSMonth,
    militaryETSDay,
    militaryETSYear,
    militaryETSError,
    combatZone,
    combatZoneOperation,
    setMilitaryStatus,
    setMilitaryFamily,
    setMilitaryBranch,
    setMilitaryRank,
    setMilitaryETSMonth,
    setMilitaryETSDay,
    setMilitaryETSYear,
    rankError,
    setDisability,
    setCombatZone,
    setCombatZoneOperation,
    expanded,
  }) => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <ExpansionPanel expanded={expanded}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header">
            <Typography className={classes.heading}>
              <Icon className={classes.svg} /> {label}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanel}>
            <Typography component={'div'} className={classes.typography}>
              <RadioButtons
                label="Status"
                data={status_radio_props}
                userProp={militaryStatus}
                setMilitaryValue={setMilitaryStatus}
              />
              {isMilitaryUser(militaryStatus) && (
                <RadioButtons
                  label="Military Branch"
                  data={branch_radio_props}
                  userProp={militaryBranch}
                  setMilitaryValue={setMilitaryBranch}
                  setMilitaryRank={setMilitaryRank}
                />
              )}

              <RadioButtons
                label={projectConfig.serviceCheckTitle}
                data={disability_radio_props}
                userProp={disability}
                setMilitaryValue={setDisability}
              />
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  },
);

export default ExpansionPanelComponent;
